import React, { Fragment } from "react";
import Header from "../header/Header";
import PatientVisits from "../patient-visits/PatientVisits";
import Patients from "../patients/Patients";
export default function DashboardResearchGCU() {
  return (
    <Fragment>
      <Header />
      <PatientVisits category={"research"} study_type="GCU_CS03" />
      <Patients category={"research"} study_type="GCU_CS03" />
    </Fragment>
  );
}
